import { useCallback, type MouseEvent } from 'react';
import { useWorkspaceActions } from './WorkspaceProvider';

/**
 * A plain left click belongs to the workspace; anything with a modifier still means what
 * the browser says it means, so Ctrl-click keeps opening a real second browser tab.
 */
function isPlainClick(event: MouseEvent): boolean {
  return !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}

/**
 * Every destination in the console stays a real link with a real address, so it can be
 * copied, bookmarked, and opened in a browser tab of its own. Following one with a plain
 * click adds a document to the workspace instead of replacing what is on screen.
 */
export function useDocumentLink(): (address: string, afterwards?: () => void) => (event: MouseEvent) => void {
  const { open } = useWorkspaceActions();
  return useCallback((address: string, afterwards?: () => void) => (event: MouseEvent) => {
    afterwards?.();
    if (!isPlainClick(event)) return;
    event.preventDefault();
    open(address);
  }, [open]);
}
